import React from 'react';
import { Dispatch } from 'redux';
import { connect } from "react-redux";
import { IApplicationState, RootActionCreators } from '../../../store';
import { createStyles, makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../../organisms/PageHeader';
import { ContactpointNavigation, ContactpointNavigationPage, INavigations, mapNavigationsToProps } from '../../organisms/contactpoint/ContactpointNavigation';
import { IReportData } from "../../../entities/reports/IReportData";
import {IData as ContactpointListData} from "../../../store/contactpoint/contactpointList";
import { FetchState } from '../../../entities/FetchState';
import { ContactpointList as ContactpointListOrganism } from '../../organisms/contactpoint/ContactpointList';

// CSS
const useStyles = makeStyles((theme: Theme) =>
    createStyles({}),
); 

// Standard Properties from parent component
interface IProps { }

// Outgoing functions to parent component
interface IDispatch {}

// Properties from State 
interface IStateProps {
    list: IReportData<ContactpointListData>;
}
const mapStateProps = (state: IApplicationState): IStateProps => ({
    list: state.contactpoint.contactpointList.ContactpointList,
});

// Outgoing functions to Dispatch
interface IDispatchProps {
    navigations: INavigations;
    onLoadList: () => void;
    onClickDetails: (id: string) => void,
    onClickEdit: (id: string) => void,
}
const mapDispatchProps = (dispatch: Dispatch): IDispatchProps => ({
    navigations: mapNavigationsToProps(dispatch),
    onLoadList: () => dispatch(RootActionCreators.Contactpoint.contactpointList.FetchData()),
    onClickDetails: (id: string) => dispatch(RootActionCreators.Navigate.ToContactpointDetail(id)),
    onClickEdit: (id: string) => dispatch(RootActionCreators.Navigate.ToContactpointEdit(id)),
});

// Actual Component
export type AllProps = IProps & IDispatch & IStateProps & IDispatchProps;
export const ContactpointList = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t: tContactpoint } = useTranslation('contactpoint');

    const refresh = () => { 
        props.onLoadList();
    }
    
    // Load the list when the component mounts or when the list state is NotFetched
    React.useEffect(() => {
        refresh();
    }, []);

    return <ContactpointNavigation selected={ContactpointNavigationPage.List} navigations={props.navigations}>
            
        <PageHeader
            title={tContactpoint('title')}
            subTitle={tContactpoint('subtitle')}
            explainText={tContactpoint('explainText')}
        />

        <ContactpointListOrganism
            data={props.list.data}
            loading={props.list.state !== FetchState.Success && props.list.state !== FetchState.Error}
            hasError={props.list.state === FetchState.Error}
            errorDetails={props.list.errorMessage}
            onClickDetails={props.onClickDetails}
            onClickEdit={props.onClickEdit}
            onRefresh={refresh}
            title={tContactpoint('listTitle')}
        />

        </ContactpointNavigation>
};

export default connect(mapStateProps, mapDispatchProps)(ContactpointList);
